import React from 'react'
import { MainProductAPIEntity } from 'services/api/entities'
import { baseProductPackageVS } from 'services/validations/catalog/packages/baseProductPackage'
import ProductPackageBaseFormProvider from './ProductPackageBaseFormProvider'
import RatioMultiplier from './RatioMultiplier'
import { WithEntity } from './types'

type Props = WithEntity<MainProductAPIEntity>

const BasePackageForm: React.FC<Props> = ({ entity }) => (
  <ProductPackageBaseFormProvider
    entity={entity}
    validationSchema={baseProductPackageVS}
    presetInputFields={<RatioMultiplier />}
  />
)

export default BasePackageForm
